export const PATH_B2B_HOME = "/";
export const PATH_AUTH_HOME = "/auth/";

// Start hopper session with BE
// - send code
export const PATH_START_SESSION = `${PATH_AUTH_HOME}startsession/`;
export const PATH_INVALID_SESSION = `${PATH_AUTH_HOME}invalidsession/`;
export const PATH_END_SESSION = `${PATH_AUTH_HOME}endsession/`;
